import { Group, Text } from "@mantine/core";
import { DataResult, EntityClientAction, MultiDataMapForm } from "@mcurros2/microm";
import { IconAlertCircle, IconUserPin } from "@tabler/icons-react";
import { TiendasIcon } from "../Tiendas/Tiendas";
import { Dashboard } from "./Dashboard";

export const ACTVerVisitas: EntityClientAction = {
    name: 'ACTVerVisitas',
    label: 'Ver Visitas',
    title: <Text fw={700}>Ver Visitas</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacion'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Dashboard;
        const dashboard = new Dashboard(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';

        const parms = { ...dashboard.parentKeys, ...dashboard.def.columns.c_personal_id };

        const results = await dashboard.API.executeProc(
            dashboard.def.procs.dash_getUbicacionPersonal,
            parms
        ) as DataResult[];

        const data = results[0];
        const [lat, lng] = data.records[0] as number[];

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Personal</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <MultiDataMapForm
                autoFocus
                formMode="edit"
                key={`mapa-ubicacion-personal-${entity.def.name}`}
                title="Ubicación en tiempo real"
                mapOptions={{ center: { lat: lat, lng: lng }, zoom: 15, gestureHandling: 'greedy' }}
                
                dataMapView1={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwUbicacionPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1, longitudRecordIndex: 2,
                    tabLabel: "Personal",
                    tabIcon: IconUserPin,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                }}

                dataMapView2={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwTiendasVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4, longitudRecordIndex: 5,
                    tabLabel: "Tiendas",
                    tabIcon: TiendasIcon,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%",
                }}


                dataMapView3={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwCheckinVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6, longitudRecordIndex: 7,
                    tabLabel: "Checkin",
                    tabIcon: TiendasIcon,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%",
                }}

                dataMapView4={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwCheckoutVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6, longitudRecordIndex: 7,
                    tabLabel: "Checkout",
                    tabIcon: TiendasIcon,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%",
                }}

                mapHeight="50vh"
            />
        });

        return false;
    }
}